import React, {useCallback} from "react";
import {useSearchParams} from "react-router-dom";
import {captureMolliePayment} from "../api/apiClient";
import {usePaymentStatusPolling} from "../hooks/usePaymentStatusPolling";
import PaymentConfirmation from "../components/PaymentConfirmation";
import {trackEvent} from "../utils/fbPixel";

const MolliePaymentCallbackPage = () => {
    const [searchParams] = useSearchParams();

    // Mollie does not append anything to the return URL, so the backend puts its own token there.
    const token = searchParams.get("token");

    const onSuccess = useCallback(() => {
        trackEvent('Purchase', {currency: 'EUR'});
    }, []);

    const {paymentStatus, errorMessage} = usePaymentStatusPolling(captureMolliePayment, token, onSuccess);

    return (
        <PaymentConfirmation
            paymentStatus={paymentStatus}
            paymentProvider="Pay by Bank"
            generalErrorMessage={errorMessage || undefined}
        />
    );
};

export default MolliePaymentCallbackPage;
